module.exports = __webpack_public_path__ + "47d05be4511278e94b2396d00bf862a8.pdf";